/**
 * Utility for managing pinned conversations using localStorage
 * Stores pinned conversation IDs per user
 */

const PINNED_CONVERSATIONS_KEY = 'pinned_conversations';

/**
 * Get pinned conversation IDs for a user
 */
export function getPinnedConversations(userId: string): string[] {
  try {
    const stored = localStorage.getItem(`${PINNED_CONVERSATIONS_KEY}_${userId}`);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * Pin a conversation for a user
 */
export function pinConversation(userId: string, conversationId: string): void {
  const pinned = getPinnedConversations(userId);
  if (!pinned.includes(conversationId)) {
    pinned.push(conversationId);
    localStorage.setItem(`${PINNED_CONVERSATIONS_KEY}_${userId}`, JSON.stringify(pinned));
  }
}

/**
 * Unpin a conversation for a user
 */
export function unpinConversation(userId: string, conversationId: string): void {
  const pinned = getPinnedConversations(userId);
  const filtered = pinned.filter(id => id !== conversationId);
  localStorage.setItem(`${PINNED_CONVERSATIONS_KEY}_${userId}`, JSON.stringify(filtered));
}

/**
 * Toggle pin status for a conversation
 */
export function togglePinConversation(userId: string, conversationId: string): boolean {
  const pinned = getPinnedConversations(userId);
  if (pinned.includes(conversationId)) {
    unpinConversation(userId, conversationId);
    return false;
  } else {
    pinConversation(userId, conversationId);
    return true;
  }
}

/**
 * Check if a conversation is pinned
 */
export function isConversationPinned(userId: string, conversationId: string): boolean {
  return getPinnedConversations(userId).includes(conversationId);
}
